import {
  Component,
  Input,
  OnChanges,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ReplacementOffer } from '@dgx-pr-spa/shared/util';
import { OfferType } from '@dgx-pr-spa/shared/util';
import { Comparison } from '@dgx-pr-spa/shared/util';

@Component({
  selector: 'app-compare-cards',
  templateUrl: './compare-cards.component.html',
  styleUrls: ['./compare-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompareCardsComponent implements OnChanges {
  /**
   * Emits an object of type Offer back to the parent component
   */
  @Output() selected: EventEmitter<ReplacementOffer> = new EventEmitter();

  /**
   * Emits an object of type Offer back to the parent component - needed for GA
   */
  @Output() removed: EventEmitter<ReplacementOffer> = new EventEmitter();

  /**
   * Receives array of comparisons to compare
   */
  @Input() comparisons = [] as Comparison[];

  /**
   * Optional value to set specific styles and markup for medium overlay compare-cards.
   * These include stacking at mobile, full border and margins and no product CTA.
   */
  @Input() mdOverlay?: boolean;

  /**
   * The maximum number of cards visible
   */
  maxCards = 3;

  /**
   * Offer Type values used to determine if enhanced model
   */
  offerType = OfferType;

  /**
   * A placeholder image
   */
  imageNotAvailable = './assets/images/img-unavailable-large-x2.png';

  /**
   * Fires when cta is clicked - passes in replacement offer
   */
  onSelect(comparison: ReplacementOffer) {
    this.selected.emit(comparison);
  }

  /**
   * Fires when card-close is clicked - passes event object and current replacement offer
   */
  onRemove(event, comparison: ReplacementOffer) {
    // prevent event bubbling and the overlay closing when
    // remove card is clicked and there are 2 cards in comparison
    event.stopPropagation();
    this.removed.emit(comparison);
  }

  /**
   * OnChanges detects if mdOverlay and then calls fillComparisons()
   */
  ngOnChanges() {
    if (this.mdOverlay) {
      this.fillComparisons();
    }
  }

  /**
   * Fills compsarisons array to a max length with empty values
   */
  fillComparisons() {
    const empty = Array(this.maxCards).fill(null);
    this.comparisons = [...this.comparisons, ...empty].slice(0, this.maxCards);
  }
}
